<!-- 
// ============================================
// 10. ProductDescription.vue
// ============================================ -->
<template>
    <div class="info-block">
        <h3>{{ $t('product.description') }}</h3>
        <p class="description-text">
            {{ description || $t('product.noDescription') }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'ProductDescription',
    props: {
        description: {
            type: String,
            default: ''
        }
    }
};
</script>

/* ============================================
   10. ProductDescription.vue
   ============================================ */
<style scoped>
.info-block {
    margin-top: 30px;
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #e8e8e8;
}

.info-block h3 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 15px;
    color: var(--color-3);
}

.description-text {
    font-size: 15px;
    line-height: 1.6;
    color: var(--color-5);
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

@media (max-width: 576px) {
    .info-block {
        margin-bottom: 25px;
        padding-bottom: 25px;
    }

    .info-block h3 {
        font-size: 16px;
    }
}
</style>
